import { specialFont } from '../../Infrastructure/Theme/fontFamily'

const cancellationPolicySx = {
    mainBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
        mt: 8,
    },
    title: {
        fontFamily: specialFont,
    },
    description: {
        px: 3,
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 400,
        fontFamily: 'Inter',
    },
}

export { cancellationPolicySx }
